import { HierarchyContext } from '@plarium/hierarchy-react';
import React, { useContext } from 'react';

import { FormContext, FormField, getIn } from '@gogame/form';

import { NAME as AUDIENCE_NAME } from 'scenes/CustomAudiences/Audiences/components/AudienceForm/GeneralFieldSet/constants';
import {
  ACCOUNT,
  DATA_TYPE,
  NAME,
  PARENT_AUDIENCE,
  PARTNER,
  IS_AUTO_SYNC,
  INCLUDE_DEPOSIT_VALUES,
  DESCRIPTION,
  CREDENTIALS,
} from 'scenes/CustomAudiences/PartnerAudiences/components/PartnerAudienceForm/constants';
import {
  loadName,
  loadDataTypes,
  loadAccounts,
  loadCredentials,
} from 'scenes/CustomAudiences/PartnerAudiences/sources/fields';

export const AutoSync = (props) => (
  <FormField.Switch
    padding={0}
    name={IS_AUTO_SYNC}
    label={'Autosync'}
    labelPlacement={'start'}
    {...props}
  />
);

export const DataType = ({ path, externalDepends = [], required }) => (
  <FormField.Select
    name={DATA_TYPE}
    depends={[`${path}.${PARTNER}`, ...externalDepends]}
    source={loadDataTypes}
    label={'Data type'}
    placeholder={'Select data type'}
    padding={0}
    required={required}
  />
);

export const Account = ({ path, externalDepends = [], required, disabled }) => (
  <FormField.Select
    name={ACCOUNT}
    depends={[
      `${path}.${PARTNER}`,
      `${path}.${CREDENTIALS}`,
      ...externalDepends,
    ]}
    source={loadAccounts}
    label={'Account'}
    placeholder={'Select account'}
    padding={0}
    required={required}
    disabled={disabled}
    active={!disabled}
  />
);

function normalizeCredentials(v, data) {
  if (!v && data?.length === 1) {
    return data[0].id;
  }
  return v;
}
export const Credentials = ({ path, externalDepends = [] }) => {
  const { state } = useContext(HierarchyContext);
  const credentials = getIn(state, `${path}.${CREDENTIALS}.data`);
  const credentialsCount = credentials?.length || 0;
  return (
    <FormField.Select
      name={CREDENTIALS}
      depends={[`${path}.${PARTNER}`, ...externalDepends]}
      source={loadCredentials}
      label={'Credentials'}
      placeholder={'Select credentials'}
      padding={0}
      normalizeValue={normalizeCredentials}
      required={!!credentialsCount}
      disabled={!credentialsCount || credentialsCount <= 1}
    />
  );
};

export const PartnerName = ({ path, required }) => {
  const { values } = useContext(FormContext);
  const parentAudience = getIn(values, PARENT_AUDIENCE);
  const audienceName = getIn(values, NAME);

  return (
    <FormField.TextField
      name={NAME}
      required={required}
      depends={[
        ...(audienceName ? [AUDIENCE_NAME] : []),
        ...(parentAudience ? [PARENT_AUDIENCE] : []),
        `${path}.${PARTNER}`,
        `${path}.${DATA_TYPE}`,
        `${path}.${ACCOUNT}`,
        `${path}.${CREDENTIALS}`,
        `${path}.${INCLUDE_DEPOSIT_VALUES}`,
      ]}
      label={'Name'}
      source={loadName}
      padding={0}
    />
  );
};

export const Description = ({ required }) => (
  <FormField.TextField
    multiline={true}
    minRows={1}
    name={DESCRIPTION}
    label={'Description'}
    padding={0}
    required={required}
  />
);
